import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/organizations',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'settings.organizations',
        },
        children: [
            {
                path: '',
                name: 'organizations-list',
                component: () => import('./views/OrganizationList.vue'),
            },
            {
                path: 'create',
                name: 'organizations-create',
                component: () => import('./views/OrganizationCreate.vue'),
            },
            {
                path: ':id',
                name: 'organizations-detail',
                component: () => import('./views/OrganizationDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
